import React, { PureComponent } from 'react'
import PropTypes                from 'prop-types'
import './index.less'

class Search extends PureComponent {

  static propTypes = {
    placeholder: PropTypes.string,
    onSearch: PropTypes.func,
  }

  static defaultProps = {
    placeholder: '搜索',
    onSearch: () => {
    },
  }

  state = {
    value: this.props.value?this.props.value:'',
  }

  throttle = null

  input = null

  handleSearch(e) {
    const { value } = e.target
    clearTimeout(this.throttle)
    this.throttle = setTimeout(() => {
      this.props.onSearch(value.trim())
    }, 100)
    this.setState({ value })
  }

  handleClear() {
    sessionStorage.clear();
    this.props.onSearch('')
    this.setState({ value: '' })
    this.input.focus();
  }
  reset() {
    this.handleClear()
  }
  render() {
    const { value } = this.state
    const { placeholder } = this.props
    let valueTrim = value.trim()||this.props.value;
    return (
      <div className="search-wrapper">
        <input
          ref={ref => this.input = ref}
          type="search"
          placeholder={placeholder}
          value={value}
          onChange={this.handleSearch.bind(this)}/>
        {valueTrim && <svg className="icon icon-cancle_icon" onClick={this.handleClear.bind(this)}>
          <use xlinkHref="#icon-cancle_icon"></use>
        </svg>}
        {!valueTrim && <svg className="icon icon-search_icon">
          <use xlinkHref="#icon-search_icon"></use>
        </svg>}
      </div>
    )
  }
}

export default Search



// WEBPACK FOOTER //
// ./src/components/Search/index.js